var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logoIcon_svg__a)",
    transform: "rotate(-9.65 40.383 40.135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.383,
    cy: 40.135,
    r: 34.5,
    fill: "#E84C15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.383,
    cy: 40.135,
    r: 32.344,
    stroke: "#EFE6CC",
    strokeWidth: 4.313
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFE6CC",
    fillRule: "evenodd",
    d: "m43.416 58.21 3.494-5.614c8.55-13.82 8.802-22.13 1.027-27.744-6.565-4.729-14.437-3.74-19.319 2.719-5.968 7.884-2.715 18.014 8.231 25.903l6.565 4.729zm-2.154-12.914c3.89-.661 6.409-4.895 5.633-9.459s-4.56-7.726-8.443-7.066-6.409 4.895-5.633 9.46c.776 4.563 4.56 7.725 8.443 7.065",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logoIcon_svg__a",
    width: 69.304,
    height: 69.304,
    x: 5.878,
    y: 5.63,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.293,
    dy: 0.293
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_775_484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_775_484",
    result: "shape"
  })))));
};
export default SvgLogoIcon;